/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Delete_Allocation_WarningInputs */

const en_admin_allocation_form_delete_allocation_warning = /** @type {(inputs: Admin_Allocation_Form_Delete_Allocation_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will delete the allocation and any record of it. To end an allocation, you should instead set its end date. The member or team will not be notified.`)
};

const de_admin_allocation_form_delete_allocation_warning = /** @type {(inputs: Admin_Allocation_Form_Delete_Allocation_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zuweisung und alle damit verbundenen Daten werden entfernt. Um eine Zuweisung zu beenden, lege stattdessen ein Enddatum fest. Das Mitglied oder Team wird nicht benachrichtigt.`)
};

const es_admin_allocation_form_delete_allocation_warning = /** @type {(inputs: Admin_Allocation_Form_Delete_Allocation_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto eliminará la asignación y cualquier registro de ella. Para finalizar una asignación, establece su fecha de fin. El miembro o equipo no será notificado.`)
};

const fr_admin_allocation_form_delete_allocation_warning = /** @type {(inputs: Admin_Allocation_Form_Delete_Allocation_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela supprimera l'attribution et tout enregistrement de celle-ci. Pour mettre fin à une attribution, définissez plutôt sa date de fin. Le membre ou l'équipe ne sera pas notifié.`)
};

/** @type {(inputs: Admin_Allocation_Form_Delete_Allocation_WarningInputs) => LocalizedString} */
const it_admin_allocation_form_delete_allocation_warning = en_admin_allocation_form_delete_allocation_warning;

/** @type {(inputs: Admin_Allocation_Form_Delete_Allocation_WarningInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_delete_allocation_warning = en_admin_allocation_form_delete_allocation_warning;

/** @type {(inputs: Admin_Allocation_Form_Delete_Allocation_WarningInputs) => LocalizedString} */
const pl_admin_allocation_form_delete_allocation_warning = en_admin_allocation_form_delete_allocation_warning;

/** @type {(inputs: Admin_Allocation_Form_Delete_Allocation_WarningInputs) => LocalizedString} */
const hu_admin_allocation_form_delete_allocation_warning = en_admin_allocation_form_delete_allocation_warning;

/** @type {(inputs: Admin_Allocation_Form_Delete_Allocation_WarningInputs) => LocalizedString} */
const ro_admin_allocation_form_delete_allocation_warning = en_admin_allocation_form_delete_allocation_warning;

/**
* | output |
* | --- |
* | "This will delete the allocation and any record of it. To end an allocation, you should instead set its end date. The member or team will not be notified." |
*
* @param {Admin_Allocation_Form_Delete_Allocation_WarningInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_delete_allocation_warning = /** @type {((inputs?: Admin_Allocation_Form_Delete_Allocation_WarningInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Delete_Allocation_WarningInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_delete_allocation_warning(inputs)
	if (locale === "de") return de_admin_allocation_form_delete_allocation_warning(inputs)
	if (locale === "es") return es_admin_allocation_form_delete_allocation_warning(inputs)
	if (locale === "fr") return fr_admin_allocation_form_delete_allocation_warning(inputs)
	if (locale === "it") return it_admin_allocation_form_delete_allocation_warning(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_delete_allocation_warning(inputs)
	if (locale === "pl") return pl_admin_allocation_form_delete_allocation_warning(inputs)
	if (locale === "hu") return hu_admin_allocation_form_delete_allocation_warning(inputs)
	return ro_admin_allocation_form_delete_allocation_warning(inputs)
});
export { admin_allocation_form_delete_allocation_warning as "admin.allocation_form.delete_allocation_warning" }